import { render, staticRenderFns } from "./ModalPaymentNotSet.vue?vue&type=template&id=8181352c&scoped=true"
import script from "./ModalPaymentNotSet.vue?vue&type=script&lang=js"
export * from "./ModalPaymentNotSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8181352c",
  null
  
)

export default component.exports